// @flow
import React from "react";
import { Link } from "react-router-dom";
import { Trans, useTranslation } from "react-i18next";
import classnames from "classnames";

import { Button } from "shared/formElements";
import { gaswechselUrl, stromwechselUrl } from "modules/MyShortOffers/misc/Routes";
import { isMobile } from "Commons/Utilities";
import { ReactComponent as RemindMeLogo } from "Commons/Assets/icons/remindme-logo.svg";

import Soeren from "Commons/Assets/images/Soeren.png";
import SoerenSignature from "Commons/Assets/images/Soerensignature.jpg";
import { ReactComponent as Phone } from "Commons/Assets/icons/phone.svg";
import { ReactComponent as WhatsApp } from "Commons/Assets/icons/whatsapp.svg";
import { ReactComponent as Email } from "Commons/Assets/icons/email.svg";
import { ReactComponent as ArrowRight } from "Commons/Assets/icons/Arrow_right.svg";

import Styles from "./AgentMessage.module.scss";

type Props = {
  offerExist: boolean,
  categoryName: string,
  savings: number,
};

const linkUrl = "/hd/wichtige-hinweise-zur-aktuellen-energiepreisentwicklung";

const AgentMessage = ({ offerExist, categoryName, savings }: Props) => {
  const { t } = useTranslation("offerPageDetail");

  let title = t("hero.title", { categoryName: categoryName ? t(`categories:${categoryName}`) : "" });
  let description = "";
  let className = null;

  if (savings >= 100) {
    description = offerExist ? (
      <Trans t={t} i18nKey={isMobile() ? "hero.shortDesc" : "hero.description"}>
        <p />
      </Trans>
    ) : (
      <Trans t={t} i18nKey="noOffer.description">
        <p />
      </Trans>
    );
  } else if (savings >= 0 && savings <= 100) {
    description = (
      <>
        <Trans t={t} i18nKey={"zeroto100Savings.description"}>
          <p className={Styles.bold} />
          <p />
          <p className={classnames(Styles.bold, Styles.removeMargin)} />
          <Link target="_blank" rel="noopener noreferrer" to={linkUrl}>
            Link
          </Link>
        </Trans>
        <div className={Styles.promise}>
          <RemindMeLogo className={Styles.remindmeLogo} />
          <span>{t("zeroto100Savings.promise")}</span>
        </div>
      </>
    );
  } else if (savings <= 0) {
    description = (
      <>
        <Trans t={t} i18nKey={`noSavings.description_${categoryName.toLowerCase()}`}>
          <p className={classnames(Styles.bold)} />
          <p className={Styles.removeMargin} />
          <p />
          <p className={classnames(Styles.bold, Styles.removeMargin)} />
        </Trans>
        <div className={Styles.promise}>
          <RemindMeLogo className={Styles.remindmeLogo} />
          <span className={Styles.promise}>
            <Trans t={t} i18nKey={"noSavings.promise"}>
              <b>text</b>
            </Trans>
          </span>
        </div>
      </>
    );
  }

  const createOfferCategoryLink = categoryName === "strom" ? stromwechselUrl : gaswechselUrl;

  return (
    <div className={Styles.agentMessage}>
      <h4>{title}</h4>
      <div className={classnames(className, Styles.message)}>
        {description}
        <div className={Styles.signature}>
          <Trans t={t} i18nKey="hero.signature">
            <br />
          </Trans>
          <img src={SoerenSignature} alt="Sören Signature" />
        </div>
        {(!offerExist || savings <= 0) && (
          <Link className={Styles.ctaBtn} to={createOfferCategoryLink + "?utm_campaign=newofferafterempty"}>
            <Button>
              {t("noOffer.getNewOfferLink")}
              <ArrowRight className={Styles.buttonArrow} />
            </Button>
          </Link>
        )}
      </div>
      <div className={Styles.profile}>
        <img src={Soeren} alt="Sören Gruber" />
        <div className={Styles.signature}>
          <img src={SoerenSignature} alt="Sören Signature" />
          <h5>{t("hero.contactName")}</h5>
          <h6>{t("hero.contactTitle")}</h6>
        </div>
      </div>
      <div className={Styles.contact}>
        <a href={t("common:contactOptions.phoneCall")}>
          <Phone />
          <span>{t("common:contactOptions.phone")}</span>
        </a>
        <a href={t("common:contactOptions.whatsappCall")}>
          <WhatsApp />
          <span>{t("common:contactOptions.whatsappNumber")}</span>
        </a>
        <a href={t("common:contactOptions.emailCall")}>
          <Email />
          <span>{t("common:contactOptions.email")}</span>
        </a>
      </div>
    </div>
  );
};

export default AgentMessage;
